import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutPutItem } from '../../../services/recommendation-services.service';
import { trigger, transition, style, animate, query, stagger,AnimationEvent, state } from '@angular/animations';

@Component({
  selector: 'ubs-output-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './output-items.component.html',
  styleUrls: ['./output-items.component.scss'],
  animations: [
      /* trigger('fadeIn', [
        transition(':enter', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
        ])
      ]),
      trigger('listAnimation', [
        transition('* => *', [
          query(':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            stagger(100, [
              animate('500ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
            ])
          ], { optional: true })
        ])
      ]), */
      // Animation for the container itself
    /* trigger('containerAnimation', [
      // Initial state is off-screen to the left
      state('inactive', style({
        transform: 'translateX(-100%)',
        opacity: 0
      })),
      // Final state is in its normal position
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      // Transition from inactive to active
      transition('inactive => active', [
        animate('400ms ease-out')
      ])
    ]), */
    trigger('containerAnimation', [
      state('inactive', style({ opacity: 0, transform: 'translateY(20px)' })),
      state('active', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('inactive => active', animate('300ms ease-out')),
    ]),
    
    // Animation for the list items inside the container
    /* trigger('itemsAnimation', [
      transition('inactive => active', [
        query(':enter', [
          style({ transform: 'translateX(-50px)', opacity: 0 }),
          stagger('{{ staggerDelay }}ms', [
            animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
          ])
        ], { optional: true })
      ]),
      transition('* => inactive', [
        query(':leave', [
          stagger('{{ staggerDelay }}ms', [
            animate('300ms ease-out', style({ transform: 'translateX(-50px)', opacity: 0 }))
          ])
        ], { optional: true })
      ])
    ]), */
    trigger('itemsAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(10px)' }),
          stagger('50ms', [
            animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ],{ 
        // Default parameter defined HERE at the TRANSITION level
        params: { staggerDelay: '50ms' } 
      })
    ])
    ]
})
export class OutputItemsComponent implements OnChanges{
  
  @Input() outputItem:OutPutItem;
  visibleItems: string[] = [];
  private cleanup: (() => void)[] = [];

  /* @Input() set animationState(value: 'active' | 'inactive') {
    this._animationState = value;
    if (value === 'inactive') {
      this.visibleItems = [];
    }
  } */
  /* @Input() set animationState(value: 'active' | 'inactive') {
    this._animationState = value;
    // Reset visible items only when going inactive->active
    if (value === 'active' && this.visibleItems.length === 0) {
      this.visibleItems = this.outputItem?.items || [];
    }
  } */
  @Input() set animationState(value: 'active' | 'inactive') {
    if (this._animationState === value) return; // Prevent unnecessary changes
    
    this._animationState = value;
    
    if (value === 'active') {
      // Only populate items when activating
      this.visibleItems = this.outputItem?.items || [];
      this.itemsAnimationState = 'active';
    } else {
      // Clear items when deactivating
      this.visibleItems = [];
      this.itemsAnimationState = 'inactive';
    }
  }
  get animationState(): 'active' | 'inactive' {
    return this._animationState;
  }
  
  @Output() animationComplete = new EventEmitter<void>();
  
  private _animationState: 'active' | 'inactive' = 'inactive';

  itemsAnimationState: string = 'inactive';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['outputItem'] && this.outputItem) {
      this.streamContent(this.outputItem);
    }
  }

  private async streamContent(outputItem: OutPutItem) {
    // Stream items
    for (const item of outputItem.items) {
      await this.delay(800);
      this.visibleItems = [...this.visibleItems, item];
    }
  }
  private delay(ms: number): Promise<void> {
    return new Promise(resolve => {
      const timer = setTimeout(() => resolve(), ms);
      this.cleanup.push(() => clearTimeout(timer));
    });
  }
  //Animation funtions
    // Called when the container animation is complete
    onContainerAnimationComplete(event: AnimationEvent) {
      if (event.toState === 'active' && event.phaseName === 'done') {
        // When container animation completes, start showing items
        this.visibleItems = this.outputItem?.items || [];
        this.itemsAnimationState = 'active';
      }
    }
    
    // Called when the items animation is complete
    onItemsAnimationComplete(event: AnimationEvent) {
      if (event.phaseName === 'done') {
        // When items animation completes, emit event to parent
        this.animationComplete.emit();
      }
    }
    //May have to delete this
    // Public method to start the animation sequence
    startAnimation(): void {
      this.animationState = 'active';
    }
    //May have to delete
    // Public method to reset the animation
    resetAnimation(): void {
      this.itemsAnimationState = 'inactive';
      this.animationState = 'inactive';
    }

}
